"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseToState = void 0;
var utils_1 = require("../../../utils");
var _1 = require(".");
var supplyIsFuel = function (supply, fuel) {
    return supply.fuel.toLowerCase() === fuel;
};
function responseToState(_a) {
    var readings = _a.readings, supplies = _a.supplies, latestBilling = _a.latestBilling, supplyRegisterInfo = _a.supplyRegisterInfo;
    return {
        readings: {
            gas: readings.gas,
            electricity: readings.electricity,
        },
        supplies: {
            gas: supplies
                .filter(function (supply) { return supplyIsFuel(supply, 'gas'); })
                .map(function (supply) {
                return (0, _1.getSupplyMeterInfo)((0, utils_1.filterReadsMPXN)(readings.gas, supply.mpxn), supply);
            }),
            electricity: supplies
                .filter(function (supply) { return supplyIsFuel(supply, 'electricity'); })
                .map(function (supply) {
                return (0, _1.getSupplyMeterInfo)((0, utils_1.filterReadsMPXN)(readings.electricity, supply.mpxn), supply, supplyRegisterInfo);
            }),
        },
        latestBilling: latestBilling,
    };
}
exports.responseToState = responseToState;
